"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorStep = void 0;
const react_1 = __importDefault(require("react"));
const theme_1 = require("../utils/theme");
const css_manager_1 = require("@food/css-manager");
const Button_1 = require("@food/ui/build/dist/src/Button");
const ErrorStep = ({ t, isModal, close, error, supportEmail, }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("h2", null,
            t `Authentication error`,
            " :("),
        react_1.default.createElement("section", null,
            react_1.default.createElement("div", null, error || t `Unknown error`),
            react_1.default.createElement("p", null,
                t `If the problem persists`,
                ' ',
                react_1.default.createElement("a", { href: `mailto:${supportEmail}` }, t `contact us`),
                "."),
            react_1.default.createElement("div", { className: (0, css_manager_1.classNames)(theme_1.footer, (0, css_manager_1.subClass)(theme_1.footer, 'centered')) },
                react_1.default.createElement(Button_1.Button, { label: t(isModal ? 'Close' : 'Proceed'), onClick: close })))));
};
exports.ErrorStep = ErrorStep;
//# sourceMappingURL=ErrorStep.js.map